import { materializeLoopQuestion } from './materialize-loop-question.function';
import { loopCatalogue } from './validate-loop-contract.function';
import { BlockType } from '../models/block-type.enum';
import { QuestionType } from '../models/question-type.enum';
import { Question } from '../models/question.model';
import { SurveyModel } from '../models/survey.model';

/** Current selection definitions, including zero-response loop instances and permanent index gaps. */
export function currentSurveyQuestions(survey: SurveyModel): Question[] {
  const templates = (survey.pages ?? []).flatMap((page) => page.questions);
  const loops = (survey.blocks ?? []).filter((block) => block.type === BlockType.Loop);
  const loopByQuestion = new Map(loops.flatMap((loop) => loop.groupedQuestionIds.map((id) => [id, loop] as const)));
  const questions = [...(survey.sources ?? []).flatMap((source) => source.variables ?? []), ...templates, ...(survey.questionsHidden ?? [])].filter(
    (question) => question.variableRequiredType !== 'UNIQUE'
  );
  return questions.flatMap((template) => {
    const loop = loopByQuestion.get(template.id);
    if (loop) {
      const loopQuestions = templates.filter((candidate) => loop.groupedQuestionIds.includes(candidate.id));
      return loopCatalogue(survey, loop).map((source) => materializeLoopQuestion(template, loopQuestions, loop, source));
    }
    const question = JSON.parse(JSON.stringify(template)) as Question;
    if (!question.type && question.variableRequiredType) {
      question.type = (question.variableRequiredType as string) === 'TEXT' || !question.options?.length ? QuestionType.Input : QuestionType.SingleChoice;
    }
    return [question];
  });
}
